<template>
  <header class="pure-g">
    <div class="pure-u-1 pure-u-md-3-5">
      <a v-if="info_url" :href="info_url" target="_blank"><img src="../../assets/images/tavour-orange-black.svg"></a>
      <img v-else src="../../assets/images/tavour-orange-black.svg">
    </div>
    <div class="pure-u-1 pure-u-md-2-5 text-right margin-25-top-sm margin-bottom-10">
      <span class="question-text responsive">Question? (206) 486-0669 <br> support@tavour.com</span>
    </div>
  </header>
</template>

<script>
  import store from '../../lib/store';

  export default {
    name: 'pageHeader',
    data() {
      return {
        info_url: store.get('info_url'),
      };
    },
  };
</script>

<style scoped>
  header {
    display: block;
    padding: 1px;
    background-color: #464545;
    margin-bottom: 10px;
  }

  .question-text {
    display: inline;
    text-align: right;
    font-size: 15px;
    color: #FFFFFF;
    letter-spacing: -0.25px;
    padding-right: 20px;
    font-weight: 100;
  }

  img {
    display: inline;
    margin: 10px;
    width: 200px;
  }

</style>



// WEBPACK FOOTER //
// PageHeader.vue?e52712ba